export const editLogicToolFormNamePrefix = 'edit-logic-tool-form-';

const generateEditLogicToolFormName = uuid =>
  editLogicToolFormNamePrefix + uuid;

export default generateEditLogicToolFormName;
